/**
 * Created by Josef Jurca on 03/10/2017.
 */

import {
    ActionTypes,
    PaymentHistoryStates
} from 'store/actions/pages/paymenthistory';

const defaultState = {
        status: PaymentHistoryStates.INITIAL,
        history: []
    },

    /**
     * Sets payment history state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setPaymentHistoryState = function (state, action) {

        return {
            ...state,
            status: action.state
        };
    },

    /**
     * Sets payment history data in case of the corresponding action.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setPaymentHistoryData = function (state, action) {

        return {
            ...state,
            history: action.state
        };
    },


    /**
     * Returns the payment history state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    paymentHistory = function (state = defaultState, action) {

        switch (action.type) {

            case ActionTypes.SET_PAYMENT_HISTORY_STATE:
                return (state = setPaymentHistoryState(state, action));

            case ActionTypes.SET_PAYMENT_HISTORY_DATA:
                return (state = setPaymentHistoryData(state, action));

            default:
                return state;
        }
    };

export default paymentHistory;


// WEBPACK FOOTER //
// ./src/js/store/reducers/pages/paymenthistory.js